import React from "react";
import styles from "./banner.module.scss";

const Banner = (props) => {
  const { imageUrl, heading, subHeading } = props;

  const bannerImage = {
    // backgroundColor: "#fefefe",
    backgroundImage: `url(${imageUrl})`,
    // background: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))",
  };

  return (
    <div className={styles.heroImage} style={bannerImage}>
      <div className={styles.title}>
        {heading}
        <strong>{subHeading}</strong>
      </div>
    </div>
  );
};

export default Banner;
